export type VisibilityType = 'visible' | 'hidden';
type ViewVisibility = {
  [viewId: string]: VisibilityType | undefined;
};

// base64 encoded: `hugot-director-webclient:view-visibility@1`
// if you need to modify a schema of value, you also modify this key and need to migrate them
const STORAGE_KEY = 'aHVnb3QtZGlyZWN0b3Itd2ViY2xpZW50OnZpZXctdmlzaWJpbGl0eUAxCg==';

class ViewVisibilityStorage {
  private readonly storage: Storage;

  constructor({ storage }: { storage: Storage }) {
    this.storage = storage;
  }

  public getVisibility = (viewId: string): VisibilityType | null => {
    const jsonString = this.storage.getItem(STORAGE_KEY);

    if (!jsonString) return null;

    return deserialize(jsonString)[viewId] || null;
  };

  public saveVisibility = (viewId: string, visibility: VisibilityType): void => {
    this.mergeSave({
      [viewId]: visibility,
    });
  };

  private mergeSave = (data: Partial<ViewVisibility>): void => {
    const previousValue = deserialize(this.storage.getItem(STORAGE_KEY) || '{}');

    this.storage.setItem(STORAGE_KEY, serialize({ ...previousValue, ...data }));
  };
}

const serialize = (data: ViewVisibility): string => JSON.stringify(data);

const deserialize = (jsonString: string): ViewVisibility => {
  try {
    const json = JSON.parse(jsonString);

    return json;
  } catch (err) {
    throw new Error('Deserialization Failed.');
  }
};

export default ViewVisibilityStorage;
